import { useState } from 'react'
import RealEstatePageLayout from '../components/partials/RealEstatePageLayout'
import Link from 'next/link'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import ImageLoader from '../components/ImageLoader'
import {useTranslation} from "react-i18next";

import BgParallax from '../components/BgParallax'

const SellPage = () => {
  const { t } = useTranslation('common');


  return (
    <RealEstatePageLayout
      pageTitle={t("Vendre")}
      description={t("Vendez votre bien immobilier au Maroc avec Facilykey : estimation offerte, photos professionnelles, diffusion sur les grands portails et accompagnement jusqu'à la signature.")}
      activeNav='Pages'
    >
      <Container className='mt-5 mb-md-4 pt-5'>
        {/* Breadcrumbs */}
        <Breadcrumb className='mb-3 pt-md-3'>
          <Breadcrumb.Item linkAs={Link} href='/'>{t("Accueil")}</Breadcrumb.Item>
          <Breadcrumb.Item active>{t("Vendre")}</Breadcrumb.Item>
        </Breadcrumb>
      </Container>

      {/* Hero */}
      <Container fluid as='section' className='my-5 pb-lg-4 px-xxl-4'>
        <BgParallax
          imgSrc='/images/header/rabat_header.webp'
          priority
          type='scroll-opacity' // scale, opacity, scroll-opacity, scale-opacity
          speed={0.5} // from -1.0 to 2.0
          overlay={20} // from 0 to 100 or 'gradient' to apply gradient overlay
          contentWrapper={{
            style: {maxWidth: '856px'}
          }}
          className='card align-items-center justify-content-center border-0 p-md-5 p-4 bg-secondary overflow-hidden mt-n3'
          style={{minHeight: '50vh'}}
        >
          <h1 className='mb-5 pb-md-3 px-md-3 text-white text-center' style={{fontWeight: 'normal'}}>{t("Vendez en toute sérénité avec Facilykey")}</h1>
          {/* Action Button */}
          <Row className='d-flex justify-content-center align-items-center text-center zindex-2'>
            <Col sm={12} xl={6} className='align-items-center justify-content-center'>
              <Button as={Link} className='mb-3' href='/estimate-property' size='lg' variant='primary'>
                {t("Estimer mon bien")}
              </Button>
            </Col>
            <Col sm={12} xl={6} className='align-items-center justify-content-center'>
              <Button as={Link} className='mb-3' href='/contacts' size='lg' variant='accent'>
                {t("Trouver un conseiller")}
              </Button>
            </Col>
          </Row>
        </BgParallax>
      </Container>

      {/* Steps (How it works) */}
      <Container as='section' className='mb-5 pb-2 pb-lg-4'>
        <Row className='gy-4 pb-2 pb-sm-4 align-items-center'>
          <Col xs={12} md={5} className='text-md-start text-center'>
            <div className='d-inline-block'>
              <ImageLoader src='/images/illustrations/sell_illustration_property.jpeg' width={750} height={413} alt={t("Vendez en toute sérénité avec Facilykey")} style={{borderRadius: 30}} />
            </div>
          </Col>
          <Col xs={12} md={7} lg={{span: 6, offset: 1}}>
            <h2 className='h2 mb-lg-5 mb-sm-4'>{t("Comment nous procédons")}</h2>
            <div className='steps steps-vertical'>
              <div className='step active'>
                <div className='step-progress'><span className='step-number'>1</span></div>
                <div className='step-label ms-4'>
                  <h3 className='h5 mb-2 pb-1'>{t("Estimation personnalisée offerte")}</h3>
                  <p className='mb-0'>{t("Notre agent de votre secteur se déplace pour réaliser gratuitement un avis de valeur, afin de définir le juste prix de votre bien.")}</p>
                </div>
              </div>
              <div className='step active'>
                <div className='step-progress'><span className='step-number'>2</span></div>
                <div className='step-label ms-4'>
                  <h3 className='h5 mb-2 pb-1'>{t("Mise en valeur et diffusion")}</h3>
                  <p className='mb-0'>{t("Nos agents réalisent vos photos professionnelles et rédigent l’annonce pour mettre en avant les atouts de votre bien pour les diffuser sur les principaux portails immobiliers et de nombreux autres sites.")}</p>
                </div>
              </div>
              <div className='step active'>
                <div className='step-progress'><span className='step-number'>3</span></div>
                <div className='step-label ms-4'>
                  <h3 className='h5 mb-2 pb-1'>{t("Gestion des visites")}</h3>
                  <p className='mb-0'>{t("Votre agent partenaire vérifie la solvabilité des acquéreurs, prend en charge les visites et vous adresse ses comptes rendus.")}</p>
                </div>
              </div>
              <div className='step active'>
                <div className='step-progress'><span className='step-number'>4</span></div>
                <div className='step-label ms-4'>
                  <h3 className='h5 mb-2 pb-1'>{t("Un cadre sécurisé")}</h3>
                  <p className='mb-0'>{t("Nous vous accompagnons étape par étape jusqu’à la signature définitive. La signature du compromis et la remise des clés se font chez le notaire pour une transaction sécurisée.")}</p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Features (Why choose us?) */}
      <Container as='section' className='text-center text-md-start mb-md-4 mb-xl-5 pb-md-4'>
        <h2 className='h3 mb-4'>{t("Les valeurs FacilyKey")}</h2>
        <Row xs={1} md={3} className='pb-2'>
          <Col>
            <Card className='border-0'>
              <Card.Body>
                <div className='d-inline-block text-primary mb-3'>
                  <i className='fi-map-pins mb-3 fs-1'></i>
                </div>
                <Card.Title as='h5' className='pb-1'>{t("Proximité")}</Card.Title>
                <Card.Text className='mb-0'>{t("Parce qu’un projet immobilier est important dans une vie, la confiance et le lien sont essentiels. Votre agent FacilyKey, spécialiste sur son secteur, sera votre interlocuteur privilégié de la réflexion à l’aboutissement de votre projet immobilier.")}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card className='border-0'>
              <Card.Body>
                <div className='d-inline-block text-primary mb-3'>
                  <i className='fi-users mb-3 fs-1'></i>
                </div>
                <Card.Title as='h5' className='pb-1'>{t("Conseil")}</Card.Title>
                <Card.Text className='mb-0'>{t("Parce que votre projet immobilier est unique, nos agents ont à cœur de comprendre vos besoins, vos exigences et vos critères pour vous accompagner et vous conseiller dans la concrétisation de votre projet d'achat ou de vente.")}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card className='border-0'>
              <Card.Body>
                <div className='d-inline-block text-primary mb-3'>
                  <i className='fi-education mb-3 fs-1'></i>
                </div>
                <Card.Title as='h5' className='pb-1'>{t("Professionnalisme")}</Card.Title>
                <Card.Text className='mb-0'>{t("Parce que nous attachons une grande importance à votre satisfaction, nos conseillers immobiliers sont formés en continu dans une démarche qualité ISO 9001, et ce afin de vous apporter le meilleur des services.")}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

    </RealEstatePageLayout>
  )
}

export default SellPage
